import React from 'react';
import { Square, CheckSquare, Star, Tag } from 'lucide-react';
import { formatDistanceToNow, format, isToday, isYesterday } from 'date-fns';

const GmailEmailRow = ({ email, selected, onSelect, onClick, onToggleStar }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    if (isToday(date)) {
      return format(date, 'h:mm a');
    }
    if (isYesterday(date)) {
      return 'Yesterday';
    }
    return format(date, 'MMM d');
  };

  return (
    <div 
      className={`gmail-email-row ${!email.isRead ? 'gmail-email-row--unread' : ''}`}
      onClick={onClick}
      data-testid={`email-row-${email.id}`}
    >
      <div className="gmail-email-row-options">
        <button 
          className="gmail-checkbox-btn"
          onClick={onSelect}
        >
          {selected ? (
            <CheckSquare size={18} className="text-blue-600" />
          ) : (
            <Square size={18} />
          )}
        </button>
        <button 
          className="gmail-icon-btn gmail-star-btn"
          onClick={onToggleStar}
        >
          <Star 
            size={18} 
            className={email.isStarred ? 'gmail-star--active' : ''} 
            fill={email.isStarred ? '#f4b400' : 'none'}
          />
        </button>
        <button className="gmail-icon-btn">
          <Tag size={18} />
        </button>
      </div>
      
      <div className="gmail-email-row-sender">
        {email.fromName || email.from}
      </div>
      
      <div className="gmail-email-row-content">
        <span className="gmail-email-row-subject">{email.subject}</span>
        <span className="gmail-email-row-separator"> - </span>
        <span className="gmail-email-row-snippet">{email.snippet}</span>
      </div>
      
      <div className="gmail-email-row-date">
        {formatDate(email.date)}
      </div>
    </div>
  );
};

export default GmailEmailRow;
